module.exports = __webpack_public_path__ + "static/media/visa-electron.e3d1f565.svg";